import React, { FC, KeyboardEvent, useRef } from "react";
import classnames from "classnames";

import { SearchInputProps, Value } from "./types";
import Input from "../Input";
import Icon from "../Icon";
import { IconName } from "../Icon/types";

import "./styles.scss";

export const SearchInput: FC<SearchInputProps> = ({
  className,
  validate,
  onSearchChange,
  onSearchSubmit,
  ...props
}) => {
  const inputRef = useRef<HTMLInputElement>(null);
  const icon: IconName = "search";

  const getValue = (): Value => {
    const value = inputRef.current?.value || "";

    return { value: value, valid: validate(value) };
  };

  const handleKeyDown = (event: KeyboardEvent<HTMLInputElement>) => {
    if (event.key === "Enter") {
      handleSubmit();
    }
  };

  const handleSubmit = () => {
    onSearchSubmit(getValue());
  };

  const handleChange = () => {
    onSearchChange(getValue());
  };

  return (
    <div className="ams-search-input">
      <Input
        id="input-search"
        type="text"
        className={classnames("ams-search-input__control", className)}
        ref={inputRef}
        onChange={handleChange}
        onKeyDown={handleKeyDown}
        {...props}
      />
      <button className="ams-search-input__icon" onClick={handleSubmit}>
        <Icon>{icon}</Icon>
      </button>
    </div>
  );
};
